export const FLAGS = {
  mexico: '🇲🇽', south_africa: '🇿🇦', south_korea: '🇰🇷', czechia: '🇨🇿', canada: '🇨🇦',
  bosnia_herzegovina: '🇧🇦', switzerland: '🇨🇭', qatar: '🇶🇦', brazil: '🇧🇷', morocco: '🇲🇦',
  scotland: '\u{1F3F4}\u{E0067}\u{E0062}\u{E0073}\u{E0063}\u{E0074}\u{E007F}', haiti: '🇭🇹', united_states: '🇺🇸', australia: '🇦🇺', paraguay: '🇵🇾',
  turkiye: '🇹🇷', germany: '🇩🇪', curacao: '🇨🇼', ivory_coast: '🇨🇮', ecuador: '🇪🇨',
  netherlands: '🇳🇱', japan: '🇯🇵', tunisia: '🇹🇳', sweden: '🇸🇪', belgium: '🇧🇪',
  iran: '🇮🇷', egypt: '🇪🇬', new_zealand: '🇳🇿', spain: '🇪🇸', uruguay: '🇺🇾',
  saudi_arabia: '🇸🇦', cape_verde: '🇨🇻', france: '🇫🇷', senegal: '🇸🇳', norway: '🇳🇴',
  iraq: '🇮🇶', argentina: '🇦🇷', austria: '🇦🇹', algeria: '🇩🇿', jordan: '🇯🇴',
  portugal: '🇵🇹', colombia: '🇨🇴', uzbekistan: '🇺🇿', dr_congo: '🇨🇩', england: '\u{1F3F4}\u{E0067}\u{E0062}\u{E0065}\u{E006E}\u{E0067}\u{E007F}',
  croatia: '🇭🇷', panama: '🇵🇦', ghana: '🇬🇭',
  italy: '🇮🇹', china: '🇨🇳',
  indonesia: '🇮🇩', united_arab_emirates: '🇦🇪', poland: '🇵🇱',
};

export const POSITION_GROUPS = [
  ['门将', ['GK']],
  ['后卫', ['RB', 'CB', 'LB', 'RWB', 'LWB', 'FB']],
  ['中场', ['DM', 'CM', 'AM']],
  ['前锋', ['RW', 'LW', 'ST', 'CF', 'W']],
];

export const TEAM_STAT_GROUPS = [
  {
    title: '综合',
    items: [
      { key: 'avgPossession', label: '平均控球率', description: '已完成比赛中的平均控球率', direction: 'desc', format: 'percent' },
      { key: 'goalsFor', label: '进球', description: '球队累计进球排行', direction: 'desc', format: 'number' },
      { key: 'xg', label: '进球机会值', description: '球队累计高质量机会排行', direction: 'desc', format: 'fixed1' },
      { key: 'shots', label: '射门', description: '球队累计射门排行', direction: 'desc', format: 'number' },
    ],
  },
  {
    title: '状态',
    items: [
      { key: 'formText', label: '状态', description: '最近比赛状态序列', direction: 'form', format: 'text' },
      { key: 'winStreak', label: '连胜场次', description: '当前连续取胜场次', direction: 'desc', format: 'number' },
      { key: 'unbeatenStreak', label: '连续不败', description: '当前连续不败场次', direction: 'desc', format: 'number' },
      { key: 'winlessStreak', label: '连续不胜', description: '当前连续未取胜场次', direction: 'desc', format: 'number' },
      { key: 'scorelessStreak', label: '连续不进球场次', description: '当前连续没有进球的场次', direction: 'desc', format: 'number' },
    ],
  },
  {
    title: '纪律',
    items: [
      { key: 'yellowCards', label: '黄牌', description: '球队累计黄牌排行', direction: 'desc', format: 'number' },
      { key: 'redCards', label: '红牌', description: '球队累计红牌排行', direction: 'desc', format: 'number' },
      { key: 'fouls', label: '犯规', description: '球队累计犯规排行', direction: 'desc', format: 'number' },
    ],
  },
];

export const PLAYER_STAT_GROUPS = [
  {
    title: '进攻',
    items: [
      { key: 'goals', label: '进球', description: '球员累计进球排行', direction: 'desc', format: 'number' },
      { key: 'assists', label: '助攻', description: '球员累计助攻排行', direction: 'desc', format: 'number' },
      { key: 'xg', label: '进球机会值', description: '球员累计高质量机会排行', direction: 'desc', format: 'fixed2' },
      { key: 'shots', label: '射门', description: '球员累计射门排行', direction: 'desc', format: 'number' },
      { key: 'minutesPerGoal', label: '分钟/进球', description: '每粒进球所需分钟，进球球员优先', direction: 'ascNonZero', format: 'fixed2' },
    ],
  },
  {
    title: '综合',
    items: [
      { key: 'apps', label: '出场次数', description: '球员累计出场次数排行', direction: 'desc', format: 'number' },
      { key: 'starts', label: '首发出场', description: '出场时间达到 45 分钟的比赛场次', direction: 'desc', format: 'number' },
      { key: 'yellowCards', label: '黄牌', description: '球员累计黄牌排行', direction: 'desc', format: 'number' },
      { key: 'redCards', label: '红牌', description: '球员累计红牌排行', direction: 'desc', format: 'number' },
      { key: 'averageRating', label: '平均评分', description: '有评分出场的平均评分排行', direction: 'desc', format: 'fixed2' },
    ],
  },
  {
    title: '组织',
    items: [
      { key: 'keyPasses', label: '关键传球', description: '球员累计关键传球排行', direction: 'desc', format: 'number' },
      { key: 'passesAttempted', label: '传球', description: '球员累计传球次数排行', direction: 'desc', format: 'number' },
      { key: 'passCompletion', label: '传球成功率', description: '累计传球成功率排行', direction: 'desc', format: 'percent' },
    ],
  },
  {
    title: '守门',
    items: [
      { key: 'saves', label: '扑救', description: '门将累计扑救次数排行', direction: 'desc', format: 'number' },
    ],
  },
];

export const DEFAULT_FORMATIONS = ['4-2-3-1A', '4-1-2-2-1', '4-3-2-1S', '4-3-2-1M', '3-2-2-2-1', '3-3-2-2', '3-2-4-1', '3-2-3-2W', '3-4-1-2'];

export const TACTIC_CONTROLS = [
  { key: 'mentalityLevel', label: '心态', options: ['全力进攻', '进攻', '积极进取', '攻守平衡', '小心谨慎', '防守', '全力防守'] },
  { key: 'widthLevel', label: '宽度', options: ['收缩', '较窄', '居中', '较宽', '拉开'] },
  { key: 'tempoLevel', label: '比赛节奏', options: ['慢', '较慢', '正常', '较快', '快'] },
  { key: 'passingLevel', label: '传球偏好', options: ['长传', '直传', '混合', '偏向短传', '更多短传'] },
  { key: 'attackRouteLevel', label: '组织打法', options: ['边路', '混合', '中路'] },
  { key: 'transitionLevel', label: '组织推进', options: ['从门将开始组织', '从防线开始组织', '混合', '快速把球到中场开始组织', '快速让球到前场'] },
  { key: 'defensiveLineLevel', label: '防线', options: ['低位', '中位', '高位'] },
  { key: 'pressingLevel', label: '逼抢', options: ['低位', '中位', '高位'] },
  { key: 'possessionLevel', label: '控球倾向', options: ['放弃控球', '更少控球', '均衡', '更多控球', '完全控球'] },
];

export const FORMATION_PRESETS = [
  { name: '4-2-3-1A', description: '四后卫，两后腰，两边锋，一前腰，一中锋', levels: [2, 2, 2, 2, 1, 1, 1, 1] },
  { name: '4-2-3-1S', description: '四后卫，两后腰，一中前卫，两边锋，一中锋', levels: [3, 2, 2, 2, 1, 1, 1, 1] },
  { name: '4-3-3', description: '四后卫，三中场，三前锋', levels: [1, 4, 3, 3, 0, 0, 0, 2] },
  { name: '4-1-4-1', description: '四后卫，一后腰，四中场平行站位，一中锋', levels: [4, 0, 1, 2, 1, 4, 2, 1] },
  { name: '4-1-2-2-1', description: '四后卫，一后腰，两中前卫，两边锋，一中锋', levels: [3, 2, 2, 2, 1, 1, 1, 1] },
  { name: '4-3-1-2M', description: '四后卫，三中前卫，一前腰，两前锋', levels: [2, 0, 3, 3, 2, 0, 0, 2] },
  { name: '4-3-1-2D', description: '四后卫，三后腰，一中前卫，两前锋', levels: [5, 0, 0, 1, 1, 4, 2, 0] },
  { name: '4-3-2-1M', description: '四后卫，三中前卫，两前腰，一中锋', levels: [2, 0, 2, 3, 2, 1, 1, 1] },
  { name: '4-3-2-1D', description: '四后卫，三后腰，两中前卫，一中锋', levels: [5, 0, 0, 1, 1, 3, 2, 0] },
  { name: '4-3-2-1S', description: '四后卫，三中前卫，两边锋，一中锋', levels: [2, 4, 2, 2, 0, 1, 1, 1] },
  { name: '4-4-1-1', description: '四后卫，四中场平行站位，一前腰，一中锋', levels: [3, 2, 2, 2, 1, 1, 1, 1] },
  { name: '4-2-2-2', description: '四后卫，两后腰，两边锋，两前锋', levels: [2, 4, 3, 2, 0, 4, 0, 2] },
  { name: '4-4-2F', description: '四后卫，四中场平行站位，两前锋', levels: [3, 2, 2, 2, 1, 1, 1, 1] },
  { name: '4-4-2D', description: '四后卫，四中场菱形中场，两前锋', levels: [2, 0, 2, 3, 2, 0, 1, 1] },
  { name: '3-3-2-2', description: '三中后卫，两边翼卫，一后腰，两中场，两前锋', levels: [3, 4, 2, 2, 1, 1, 1, 1] },
  { name: '3-2-4-1', description: '三中后卫，两后腰，两边前卫，两中前卫', levels: [1, 4, 3, 2, 0, 4, 0, 2] },
  { name: '3-2-2-2-1', description: '三中后卫，两边翼卫，两中场，两边锋，一中锋', levels: [2, 4, 2, 2, 0, 1, 1, 1] },
  { name: '3-2-3-2D', description: '三中后卫，两后腰，两边前卫，一中前卫，两前锋', levels: [5, 0, 0, 1, 1, 3, 2, 0] },
  { name: '3-2-3-2W', description: '三中后卫，两边翼卫，三中场，两前锋', levels: [2, 4, 2, 2, 0, 1, 1, 1] },
  { name: '3-4-1-2', description: '三中后卫，两边翼卫，两后腰，一前腰，两中锋', levels: [1, 4, 3, 2, 1, 0, 0, 2] },
  { name: '3-4-2-1S', description: '三中后卫，两边翼卫，两后腰，两边锋，一中锋', levels: [1, 4, 3, 2, 0, 1, 0, 2] },
  { name: '3-4-2-1C', description: '三中后卫，两边翼卫，两后腰，两前腰，一中锋', levels: [2, 2, 2, 3, 2, 0, 1, 1] },
  { name: '3-4-3F', description: '三中后卫，四中场平行站位，三前锋', levels: [0, 4, 4, 3, 0, 0, 0, 2] },
  { name: '3-4-3D', description: '三中后卫，四中场菱形站位，三前锋', levels: [1, 4, 3, 2, 1, 0, 0, 2] },
  { name: '5-3-2', description: '五后卫，三中前卫，两前锋', levels: [4, 0, 0, 1, 1, 4, 2, 0] },
  { name: '5-4-1F', description: '五后卫，四中场平行站位，一中锋', levels: [5, 0, 0, 0, 1, 4, 2, 0] },
  { name: '5-4-1D', description: '五后卫，四中场菱形站位，一中锋', levels: [5, 0, 0, 1, 1, 3, 2, 0] },
  { name: '5-2-2-1', description: '五后卫，两后腰，两边锋，一前锋', levels: [4, 0, 0, 1, 1, 4, 2, 0] },
];

export const POSITION_SORT_WEIGHT = { GK: 0, RB: 1, CB: 1, LB: 1, RWB: 1, LWB: 1, FB: 1, DM: 2, CM: 2, AM: 2, LM: 2, RM: 2, RW: 3, LW: 3, ST: 3, CF: 3, W: 3 };

export const KNOCKOUT_MATCHES_PER_DAY = {
  'Round of 32': 4,
  'Round of 16': 4,
  'Quarter-final': 2,
  'Semi-final': 2,
  'Third Place': 1,
  Final: 1,
};

export const KNOCKOUT_FIXTURE_SLOTS = [
  { id: 73, stage: 'Round of 32', date: '2026-06-28 12:00', venue: 'SoFi Stadium', home: ['rank', 'A', 2], away: ['rank', 'B', 2] },
  { id: 74, stage: 'Round of 32', date: '2026-06-29 16:30', venue: 'Gillette Stadium', home: ['rank', 'E', 1], away: ['third', ['A', 'B', 'C', 'D', 'F']] },
  { id: 75, stage: 'Round of 32', date: '2026-06-29 19:00', venue: 'Estadio BBVA', home: ['rank', 'F', 1], away: ['rank', 'C', 2] },
  { id: 76, stage: 'Round of 32', date: '2026-06-29 12:00', venue: 'NRG Stadium', home: ['rank', 'C', 1], away: ['rank', 'F', 2] },
  { id: 77, stage: 'Round of 32', date: '2026-06-30 17:00', venue: 'MetLife Stadium', home: ['rank', 'I', 1], away: ['third', ['C', 'D', 'F', 'G', 'H']] },
  { id: 78, stage: 'Round of 32', date: '2026-06-30 12:00', venue: 'AT&T Stadium', home: ['rank', 'E', 2], away: ['rank', 'I', 2] },
  { id: 79, stage: 'Round of 32', date: '2026-06-30 19:00', venue: 'Mercedes-Benz Stadium', home: ['rank', 'A', 1], away: ['third', ['C', 'E', 'F', 'H', 'I']] },
  { id: 80, stage: 'Round of 32', date: '2026-07-01 12:00', venue: "Levi's Stadium", home: ['rank', 'L', 1], away: ['third', ['E', 'H', 'I', 'J', 'K']] },
  { id: 81, stage: 'Round of 32', date: '2026-07-01 17:00', venue: 'Lumen Field', home: ['rank', 'G', 1], away: ['third', ['A', 'E', 'H', 'I', 'J']] },
  { id: 82, stage: 'Round of 32', date: '2026-07-01 13:00', venue: 'BMO Field', home: ['rank', 'D', 1], away: ['third', ['B', 'E', 'F', 'I', 'J']] },
  { id: 83, stage: 'Round of 32', date: '2026-07-02 19:00', venue: 'BMO Field', home: ['rank', 'K', 2], away: ['rank', 'L', 2] },
  { id: 84, stage: 'Round of 32', date: '2026-07-02 12:00', venue: 'SoFi Stadium', home: ['rank', 'H', 1], away: ['rank', 'J', 2] },
  { id: 85, stage: 'Round of 32', date: '2026-07-02 20:00', venue: 'Lincoln Financial Field', home: ['rank', 'B', 1], away: ['third', ['E', 'F', 'G', 'I', 'J']] },
  { id: 86, stage: 'Round of 32', date: '2026-07-03 18:00', venue: 'Hard Rock Stadium', home: ['rank', 'J', 1], away: ['rank', 'H', 2] },
  { id: 87, stage: 'Round of 32', date: '2026-07-03 20:30', venue: 'Arrowhead Stadium', home: ['rank', 'K', 1], away: ['third', ['D', 'E', 'I', 'J', 'L']] },
  { id: 88, stage: 'Round of 32', date: '2026-07-03 13:00', venue: 'AT&T Stadium', home: ['rank', 'D', 2], away: ['rank', 'G', 2] },
  { id: 89, stage: 'Round of 16', date: '2026-07-04 17:00', venue: 'SoFi Stadium', home: ['winner', 73], away: ['winner', 75] },
  { id: 90, stage: 'Round of 16', date: '2026-07-04 12:00', venue: 'Gillette Stadium', home: ['winner', 74], away: ['winner', 77] },
  { id: 91, stage: 'Round of 16', date: '2026-07-05 16:00', venue: 'Estadio Azteca', home: ['winner', 76], away: ['winner', 78] },
  { id: 92, stage: 'Round of 16', date: '2026-07-05 18:00', venue: 'BC Place', home: ['winner', 79], away: ['winner', 80] },
  { id: 93, stage: 'Round of 16', date: '2026-07-06 14:00', venue: 'MetLife Stadium', home: ['winner', 83], away: ['winner', 84] },
  { id: 94, stage: 'Round of 16', date: '2026-07-06 17:00', venue: 'Mercedes-Benz Stadium', home: ['winner', 81], away: ['winner', 82] },
  { id: 95, stage: 'Round of 16', date: '2026-07-07 12:00', venue: 'Hard Rock Stadium', home: ['winner', 86], away: ['winner', 88] },
  { id: 96, stage: 'Round of 16', date: '2026-07-07 13:00', venue: 'AT&T Stadium', home: ['winner', 85], away: ['winner', 87] },
  { id: 97, stage: 'Quarter-final', date: '2026-07-09 16:00', venue: 'Gillette Stadium', home: ['winner', 89], away: ['winner', 90] },
  { id: 98, stage: 'Quarter-final', date: '2026-07-10 12:00', venue: 'SoFi Stadium', home: ['winner', 93], away: ['winner', 94] },
  { id: 99, stage: 'Quarter-final', date: '2026-07-11 17:00', venue: 'Arrowhead Stadium', home: ['winner', 91], away: ['winner', 92] },
  { id: 100, stage: 'Quarter-final', date: '2026-07-11 20:00', venue: 'Hard Rock Stadium', home: ['winner', 95], away: ['winner', 96] },
  { id: 101, stage: 'Semi-final', date: '2026-07-14 14:00', venue: 'AT&T Stadium', home: ['winner', 97], away: ['winner', 98] },
  { id: 102, stage: 'Semi-final', date: '2026-07-15 15:00', venue: 'Mercedes-Benz Stadium', home: ['winner', 99], away: ['winner', 100] },
  { id: 103, stage: 'Third Place', date: '2026-07-18 17:00', venue: 'Hard Rock Stadium', home: ['loser', 101], away: ['loser', 102] },
  { id: 104, stage: 'Final', date: '2026-07-19 15:00', venue: 'MetLife Stadium', home: ['winner', 101], away: ['winner', 102] },
];

export const BRACKET_MATCH_ORDER = {
  'Round of 32': [74, 77, 73, 75, 83, 84, 81, 82, 76, 78, 79, 80, 86, 88, 85, 87],
  'Round of 16': [90, 89, 93, 94, 91, 92, 95, 96],
  'Quarter-final': [97, 98, 99, 100],
  'Semi-final': [101, 102],
  'Third Place': [103],
  Final: [104],
};

export const knockoutTabs = [
  { key: 'bracket', label: '对阵树状图' },
  { key: 'Round of 32', label: 'Round of 32' },
  { key: 'Round of 16', label: 'Round of 16' },
  { key: 'Quarter-final', label: 'Quarter-final' },
  { key: 'Semi-final', label: 'Semi-final' },
  { key: 'Third Place', label: 'Third Place' },
  { key: 'Final', label: 'Final' },
];

export const TEAM_ODDS = {
  spain: 4.5, england: 5.5, france: 6, brazil: 8, argentina: 8, portugal: 12, germany: 12, netherlands: 20,
  norway: 25, belgium: 33, united_states: 40, switzerland: 40, colombia: 50, morocco: 50, japan: 66,
  mexico: 80, uruguay: 80, canada: 80, ecuador: 100, croatia: 100, senegal: 100, turkiye: 100,
  austria: 150, paraguay: 150, sweden: 150, scotland: 250, bosnia_herzegovina: 250, ivory_coast: 300,
  egypt: 300, czechia: 300, ghana: 400, algeria: 400, south_korea: 500, tunisia: 500, australia: 500,
  iran: 500, dr_congo: 750, south_africa: 1000, qatar: 1000, saudi_arabia: 1000, panama: 1500,
  new_zealand: 1500, iraq: 1500, cape_verde: 2000, curacao: 2000, uzbekistan: 2000, jordan: 2500,
  haiti: 3000,
  poland: 150, indonesia: 2000, united_arab_emirates: 1500,
};
